import React, { createContext, useContext, useState, useEffect } from 'react'

const CenterFilterContext = createContext()

export const useCenterFilter = () => {
  const context = useContext(CenterFilterContext)
  if (!context) {
    throw new Error('useCenterFilter must be used within CenterFilterProvider')
  }
  return context
}

export const CenterFilterProvider = ({ children }) => {
  const [selectedCenters, setSelectedCenters] = useState(() => {
    // Initialize from sessionStorage
    const stored = sessionStorage.getItem('selectedCenters')
    return stored ? JSON.parse(stored) : []
  })

  // Sync with sessionStorage whenever selectedCenters changes
  useEffect(() => {
    sessionStorage.setItem('selectedCenters', JSON.stringify(selectedCenters))
  }, [selectedCenters])

  const clearSelectedCenters = () => {
    setSelectedCenters([])
    sessionStorage.removeItem('selectedCenters')
  }

  return (
    <CenterFilterContext.Provider
      value={{
        selectedCenters,
        setSelectedCenters,
        clearSelectedCenters,
      }}
    >
      {children}
    </CenterFilterContext.Provider>
  )
}
